function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { PageEmbeddedApp } from "../page/apps";
import { PageToolbarController } from "../page/toolbar";
import Grid from "../../library/grid/grid";
import VideoHero from "../components/video-hero";
import { H2Title } from "../../library/cms/content-components";
import { TinyEditable } from "../../library/cms/editor";
import EditIcon from "../../library/cms/edit-icon";
import { MediaManagerController } from "../../library/cms/media-manager";
import LightGalleryComponent from "../../library/components/light-gallery";
import { MDCTextInput } from "../../library/components/mdc-components";

class ImageItem extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onClick", event => {
      if (this.props.onClick) this.props.onClick(this.props.index);
    });
  }

  render() {
    var item = this.props.item;
    var src = item.url + '?width=600';
    var title = item.title;
    return /*#__PURE__*/React.createElement("div", {
      "data-index": "0",
      className: "grid-element init"
    }, /*#__PURE__*/React.createElement("div", {
      className: "placeholder"
    }, /*#__PURE__*/React.createElement("div", {
      className: "image-placeholder"
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-placeholder"
    })), /*#__PURE__*/React.createElement("div", {
      className: "media"
    }, /*#__PURE__*/React.createElement("img", {
      src: src,
      loading: "lazy",
      onClick: this.onClick
    })));
  }

}

class ProjectEditDetail extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onEditImagesClick", event => {
      this.mediaController.mode = 'multi-select';
      this.mediaController.show(this.props.item.images);
    });

    _defineProperty(this, "onTitleChange", text => {
      var item = this.props.item;
      item.title = text;
      this.props.onStateChange('item', item);
    });

    _defineProperty(this, "onLocationChange", text => {
      var item = this.props.item;
      item.location = text;
      this.props.onStateChange('item', item);
    });

    _defineProperty(this, "onDescriptionChange", text => {
      var item = this.props.item;
      item.description = text;
      this.props.onStateChange('item', item);
    });

    _defineProperty(this, "onFilesSelected", files => {
      if (!files || files.length < 1) {
        files = [];
      }

      var item = this.props.item;
      item.images = files;
      this.props.onStateChange('item', item);
      setTimeout(() => {
        this.props.onLazyLoad();
      }, 500);
    });

    _defineProperty(this, "onSelectChange", event => {
      var value = this.select.value;
      var item = this.props.item;
      item.type = value;
      this.props.onStateChange('item', item);
    });

    _defineProperty(this, "onDisplayOrderChange", event => {
      var value = event.target.value;
      var item = this.props.item;

      if (value) {
        value = parseInt(value);
      } else {
        value = 0;
      }

      item.displayOrder = value;
      this.props.onStateChange('item', item);
    });
  }

  componentDidMount() {
    this.select.value = this.props.item.type;
    this.props.onLazyLoad();
  }

  componentDidUpdate() {
    this.select.value = this.props.item.type;
  }

  get images() {
    var images = this.props.item.images;
    var index = 0;
    var nodes = images.map(file => {
      index += 1;
      return /*#__PURE__*/React.createElement(ImageItem, {
        key: file.id,
        item: file,
        index: index
      });
    });
    return nodes;
  }

  rawMarkup(body) {
    if (!body) body = '';
    return {
      __html: body
    };
  }

  render() {
    var item = this.props.item;
    var images = this.images;
    var displayOrder = item.displayOrder;
    if (!displayOrder) displayOrder = '';
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(VideoHero, {
      item: item,
      active: true,
      media: this.props.media,
      onChange: this.props.onStateChange
    }), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement("header", {
      className: "center margin-top two"
    }, /*#__PURE__*/React.createElement(H2Title, {
      cls: "margin-bottom-zero",
      title: item.title,
      active: true,
      onChange: this.onTitleChange
    })), /*#__PURE__*/React.createElement("div", {
      className: "item-detail-description"
    }, /*#__PURE__*/React.createElement(TinyEditable, {
      content: item.location,
      onChange: this.onLocationChange,
      active: true
    }), /*#__PURE__*/React.createElement("div", {
      className: "margin-top margin-bottom"
    }, /*#__PURE__*/React.createElement("label", null, "Select Type:"), /*#__PURE__*/React.createElement("ui-select", null, /*#__PURE__*/React.createElement("select", {
      onChange: this.onSelectChange,
      ref: ref => this.select = ref
    }, /*#__PURE__*/React.createElement("option", {
      value: "Commercial"
    }, "Commercial"), /*#__PURE__*/React.createElement("option", {
      value: "Renovation"
    }, "Renovation"), /*#__PURE__*/React.createElement("option", {
      value: "Residential"
    }, "Residential"), /*#__PURE__*/React.createElement("option", {
      value: "Current Projects"
    }, "Current Projects")))), /*#__PURE__*/React.createElement("div", {
      className: "margin-top margin-bottom"
    }, /*#__PURE__*/React.createElement(MDCTextInput, {
      label: "Display Order",
      placeholder: "Display Order",
      value: displayOrder,
      onChange: this.onDisplayOrderChange
    })), /*#__PURE__*/React.createElement(TinyEditable, {
      content: item.description,
      cls: "item-detail-description-content",
      onChange: this.onDescriptionChange,
      active: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "item-detail-image-grid"
    }, images), /*#__PURE__*/React.createElement(EditIcon, {
      active: true,
      onClick: this.onEditImagesClick
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: "/api/MediaFile",
      data: this.props.media,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.onFilesSelected
    }))))));
  }

}

class ProjectViewDetail extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.onLazyLoad();
  }

  get images() {
    var images = this.props.item.images;
    var index = 0;
    var nodes = images.map(file => {
      index += 1;
      return /*#__PURE__*/React.createElement(ImageItem, {
        key: file.id,
        item: file,
        index: index,
        onClick: this.props.onClick
      });
    });
    return nodes;
  }

  rawMarkup(body) {
    if (!body) body = '';
    return {
      __html: body
    };
  }

  render() {
    var item = this.props.item;
    var images = this.images;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(VideoHero, {
      item: item,
      active: false
    }), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement("header", {
      className: "center margin-top two"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "margin-bottom-zero"
    }, item.title)), /*#__PURE__*/React.createElement("div", {
      className: "item-detail-description"
    }, /*#__PURE__*/React.createElement("div", null, item.location), /*#__PURE__*/React.createElement("div", {
      className: "item-detail-description-content",
      dangerouslySetInnerHTML: this.rawMarkup(item.description)
    })), /*#__PURE__*/React.createElement("div", {
      className: "item-detail-image-grid"
    }, images))));
  }

}

class ProjectDetail extends LightGalleryComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "onStateChange", (prop, value) => {
      this.state[prop] = value;
      this.setState(this.state);
    });

    _defineProperty(this, "onLazyLoad", () => {
      this.ready = false;
      var items = document.querySelectorAll('.grid-element');
      var total = items.length;
      var count = 0;
      var self = this;
      items.forEach(item => {
        var img = item.querySelector('img');
        var placeholder = item.querySelector('.placeholder');
        var media = item.querySelector('.media');

        function loaded() {
          count += 1;
          placeholder.classList.add('hide');
          item.classList.remove('init');
          media.classList.add('display');

          if (count === total) {
            self.ready = true;
          }
        }

        if (img.complete) {
          loaded();
        } else {
          img.addEventListener('load', loaded);
        }
      });
    });

    _defineProperty(this, "onClick", index => {
      if (this.ready) {
        index = index - 1;
        var data = this.getLightGalleryData(this.state.item.images, '', 1200);
        var $target = $(document.querySelector('#light-gallery'));
        this.createLightGalleryPlugin($target, data, index);
      }
    });

    this.state = {
      item: this.props.item
    };
  }

  parseEntity(entity) {
    var media = entity.media;
    media.forEach(ele => {
      if (ele.meta === 'Hero') {
        entity.heroImage = ele.url;
      } else if (ele.meta === 'Video') {
        entity.video = ele.url;
      } else if (ele.meta === 'Thumb') {
        entity.galleryImage = ele.url;
      }
    });
    return entity;
  }

  getEntity() {
    var entity = this.state.item;
    entity = this.parseEntity(entity);
    return entity;
  }

  render() {
    if (this.props.active) {
      return /*#__PURE__*/React.createElement(ProjectEditDetail, {
        item: this.state.item,
        media: this.props.media,
        onStateChange: this.onStateChange,
        onLazyLoad: this.onLazyLoad
      });
    } else {
      return /*#__PURE__*/React.createElement(ProjectViewDetail, {
        item: this.state.item,
        onLazyLoad: this.onLazyLoad,
        onClick: this.onClick
      });
    }
  }

}

export default class ProjectApp extends PageEmbeddedApp {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ProjectDetail, {
      active: this.state.component.active,
      item: this.props.initialData.entity,
      media: this.props.initialData.media,
      ref: ref => this.component = ref
    }), /*#__PURE__*/React.createElement(PageToolbarController, {
      showToolbar: this.props.initialData.showToolbar,
      onCommand: this.onCommand.bind(this),
      mode: this.mode,
      authorized: this.props.initialData.authorized,
      ref: ref => this.toolbarController = ref,
      onCreateDialogAccept: this.onCreateDialogAccept.bind(this),
      onCreateDialogCancel: this.onCreateDialogCancel.bind(this),
      onSettingsDialogAccept: this.onSettingsDialogAccept.bind(this),
      onSettingsDialogCancel: this.onSettingsDialogCancel.bind(this)
    }));
  }

}